

export default function CheckAllSVG({ className='#2D3748' }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.1673 3.5L5.75065 9.91667L2.83398 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
